import React from 'react';
import { AppBar, Container, Toolbar, Typography, Link, Box } from '@mui/material';

const footerStyle = {
  backgroundColor: '#5dade2',
  color: '#fff',
  marginTop: 'auto',
  bgcolor: '#5dade2'
};

const containerStyle = {
    minHeight: '64px',
    display: 'flex',
    flexDirection: 'column',
    bgcolor: '#5dade2'
  };

const footerTextStyle = {
  flexGrow: 1,
};

function ResponsiveFooter() {
  return (
    <AppBar position="static" style={footerStyle} sx={{ bgcolor: '#5dade2' }}>
      <Container style={containerStyle}>
        <Toolbar sx={{ bgcolor: '#5dade2' }}>
          <Typography variant="body1" style={footerTextStyle}>
            &copy; {new Date().getFullYear()} Rapid Resilience
          </Typography>
          <Link href="#" color="inherit">About</Link>
          <Box mx={2}></Box>
          <Link href="#" color="inherit">Contact</Link>
          {/* Add additional links here */}
        </Toolbar>
      </Container>
    </AppBar>
  );
}

export default ResponsiveFooter;
